import React from "react";
import { IGroupChatData } from "@home-health-notify/domain";
import PatientStatusBar from "./PatientStatusBar";
import PatientTitle from "./PatientTitle";
import ServicesToPatient from "./ServicesToPatient";
import { Box } from "@mui/material";

const PatientLessContent = ({ chatData }: { chatData: IGroupChatData }) => {
  return (
    <>
      <PatientStatusBar patientStatus={chatData.groupInfo.patientStatus} />
      <Box
        sx={{
          flexDirection: "column",
          display: "flex",
          marginLeft: "7px",
        }}
      >
        <PatientTitle
          title={chatData.groupInfo.name}
          mrn={chatData.groupInfo.mrn}
        />
        <ServicesToPatient
          servicesToPatient={chatData.groupInfo.servicesToPatient}
        />
      </Box>
    </>
  );
};

export default PatientLessContent;
